import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Ygalaad</p>
      <a className="footer-link" href="https://dashboard.ticket-box.fr">
        {t.footer.dashboardLink}
      </a>
      <a className="footer-link" href="/privacy-policy">
        {t.footer.privacyLink}
      </a>
    </footer>
  );
}

export default Footer;
